export default __webpack_public_path__ + "img/aa2f691ad4150ed8acf5967d1ccc49aa.svg";